/**
 * SemPlantaoBanner — GUPM-273 P3.
 *
 * Numa operação sob ANM Res. 95/2022, "ninguém está de vigilância" é informação
 * de primeira linha. Hoje ela só aparece para quem repara que o botão da sidebar
 * mudou de texto — e a sidebar é `hidden` no mobile, que é justamente o
 * dispositivo de quem está em campo.
 *
 * Derivado do estado, sem linha no banco: `BannerArea` só renderiza banner
 * persistido (`paebm.listBanners()`) e não serve aqui. O padrão é o do
 * `MapStatusBanners` (M2) — componente próprio, sem escrita.
 *
 * Usa a mesma query key do botão da sidebar (`shift-current-shift`), então o
 * TanStack deduplica: montar o banner no AppShell não acrescenta requisição.
 */

import { Banner } from '@/ui';
import { useCurrentShift } from './hooks';

export default function SemPlantaoBanner() {
  const { data, isPending, isError } = useCurrentShift();

  // Três estados que NÃO são ausência, e que precisam ficar calados:
  //
  //   - `isPending`: durante a primeira leitura o banner piscaria em toda
  //     navegação, e alarme que pisca sozinho é alarme que se aprende a ignorar.
  //   - `isError`: "não sei" nunca vira "não há" — a mesma regra que o
  //     `button-state` aplica ao botão (`falha-consulta`). Afirmar ausência a
  //     partir de uma consulta que falhou é inventar um fato operacional.
  //   - `data`: há plantonista, nada a dizer.
  if (isPending || isError || data) return null;

  return (
    <Banner
      tone="alerta"
      label="Plantão"
      title="⚠ Operação sem plantonista"
      description="Nenhum operador está de plantão neste momento. Em regime normal sempre há um plantonista de vigilância — um operador precisa abrir plantão."
      footnote="ANM Res. 95/2022"
      className="mb-4"
    />
  );
}
